import React from 'react';
import { IconType } from 'react-icons';
import { Box, BoxProps } from '@chakra-ui/react';

interface IconWrapperProps extends BoxProps {
  icon: IconType;
  size?: string | number;
}

// This component wraps react-icons to make them compatible with TypeScript
export const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, size = "24px", ...rest }) => {
  return (
    <Box display="inline-block" {...rest}>
      {React.createElement(Icon as any, { size })}
    </Box>
  );
};
